import { ComparisonModes } from '@/entities/market-intel/model/types';
import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetAlertsPerPersonRequestDtoSchema = z.object({
  facilityId: z.number(),
  comparisonSet: z.enum(ComparisonModes),
  from: z.string(),
  to: z.string(),
});

const GetAlertsPerPersonResponseDtoSchema = z.object({
  currentValue: z.number().nullable(),
  hint: z.string(),
  marketMedian: z.number().nullable(),
  message: z.string(),
});

export type GetAlertsPerPersonRequestDto = z.infer<
  typeof _GetAlertsPerPersonRequestDtoSchema
>;
export type GetAlertsPerPersonResponseDto = z.infer<
  typeof GetAlertsPerPersonResponseDtoSchema
>;

export const getAlertsPerPerson = (
  params: GetAlertsPerPersonRequestDto,
  config?: AxiosRequestConfig<GetAlertsPerPersonRequestDto>
) => {
  const { facilityId, ...queryParams } = params;

  return api
    .get(`/market-intelligence/facilities/${facilityId}/alerts-per-person`, {
      params: queryParams,
      ...config,
    })
    .then(responseContract(GetAlertsPerPersonResponseDtoSchema));
};
